import React from 'react';
import { Box, Flex, Icon } from '@spothero/ui';
import IconMarker from '@spothero/icons/pin-filled';
import { parseDistance } from 'utils/travel-distance';
import { useSelector } from 'react-redux';
import { getSelectedSpotDistance } from 'pages/search-transient-event-monthly/utils/spot-details-utils';
const AirportDistance = ({ spot }) => {
    const distance = getSelectedSpotDistance(spot);
    const storeState = useSelector((state) => state);
    // @ts-expect-error - parseDistance function needs to be typed first
    const airportDistance = parseDistance({
        linearMeters: distance?.distance,
        format: 'long',
    });
    const { destination: { data: { airport: { iata_code: iataCode }, }, }, } = storeState;
    return (<Flex alignItems="center" gap="0.5" mt="1">
            <Icon as={IconMarker}/>
            <Box data-testid="distance-destination" fontSize="sm">
                {airportDistance} to {iataCode}
            </Box>
        </Flex>);
};
export default AirportDistance;
